import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import Carousel from '@ertelecom/ui-react/components/carousel';

const breakpoints = {
    desktop: '1599px',
    sDesktop: '1365px',
    xsDesktop: '1279px',
    tablet: '1023px',
    mobile: '767px',
    sMobile: '680px',
};

export const CustomCarousel = styled(Carousel)`
    margin: 0 -30px;
    width: calc(100% + 60px);

    @media (max-width: ${breakpoints.desktop}) {
        margin: 0 -10px;
        width: calc(100% + 20px);
    }

    @media (max-width: ${breakpoints.mobile}) {
        & > div:first-child > div {
            touch-action: auto;
            pointer-events: initial;
        }
    }

    @media (max-width: ${breakpoints.sMobile}) {
        margin: 0;
        width: 100%;
    }
`;

export const Slide = styled.div`
    display: block;
    width: calc(100% - 60px);
    margin: 0 auto;

    @media (max-width: ${breakpoints.desktop}) {
        width: calc(100% - 20px);
    }

    @media (max-width: ${breakpoints.sMobile}) {
        width: calc(100% - 10px);
        max-width: 400px;
        margin: 0;
    }
`;

export const Counter = styled.p`
    display: none;
    margin-top: 10px;
    ${FONTS.S};
    color: ${COLORS.darkGrey};
    margin-right: 17px;
    text-align: center;
`;

export const Wrapper = styled.div`
    display: flex;
    align-self: center;
`;

export const Title = styled.h1`
    margin: 30px 0 0;
    ${FONTS.H2};
    color: ${COLORS.black};
    width: 100%;

    span {
        display:inline-block;
        width: 100%;
        ${FONTS.XXL};
        margin-top: 40px;
    }

    @media (max-width: 530px) {
        ${FONTS.H3};
    }
`;

export const Subtitle = styled.span`
    display:inline-block;
    width: 100%;
    ${FONTS.XXL};
    margin-top: 10px;
`;

export const DotWrapper = styled.div`
    align-self: center;
    z-index: 10;
    margin: -80px auto 0 20px;
`;

export const Dots = styled.div`
    width: 11px;
    height: 11px;
    border-radius: 50%;
    text-align: center;
    background: ${props => props.active ? COLORS.lightBlue : COLORS.grey};
    opacity: ${props => props.active ? 1 : 0.6};
    padding: 5px;
    margin: 0 20px 0 0;
    cursor: pointer;
    @media(min-width:767px){
        display:none;
    }
    &:hover{
        opacity: ${props => props.active ? 1 : 0.6};
        background: ${COLORS.blue}
    }

`;

export const ArrowWrapper = styled.div`
    width: calc(100% + 120px);
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: calc(50% - 32px);
    left: calc(120px / -2);
    pointer-events: none;
    z-index: 3;

    @media (max-width: ${breakpoints.mobile}) {
        display: none;
    }
`;

export const LeftArrow = styled.div`
    position: relative;
    display: flex;
    width: 63px;
    height: 63px;
    border-radius: 100%;
    background: ${COLORS.white};
    box-shadow: 0px 0px 22px 13px rgba(0, 0, 0, 0.04), 0px 0px 13px -5px rgba(0, 0, 0, 0.13);
    cursor: pointer;
    pointer-events: auto;
    visibility: ${p => p.isHide ? 'hidden' : 'visible'};
    :before {
        content: '';
        position: absolute;
        width: 17px;
        height: 17px;
        top: 50%;
        left: 50%;
        border-left: 2px solid ${COLORS.red};
        border-bottom: 2px solid ${COLORS.red};
        border-radius: 1px;
        transform-origin: center;
        transform: translate(-30%, -50%) rotate(45deg);
    }
`;

export const RightArrow = styled.div`
    position: relative;
    display: flex;
    width: 63px;
    height: 63px;
    border-radius: 100%;
    background: ${COLORS.white};
    box-shadow: 0px 0px 22px 13px rgba(0, 0, 0, 0.04), 0px 0px 13px -5px rgba(0, 0, 0, 0.13);
    cursor: pointer;
    pointer-events: auto;
    visibility: ${p => p.isHide ? 'hidden' : 'visible'};
    :before {
        content: '';
        position: absolute;
        width: 17px;
        height: 17px;
        top: 50%;
        left: 50%;
        border-right: 2px solid ${COLORS.red};
        border-bottom: 2px solid ${COLORS.red};
        border-radius: 1px;
        transform-origin: center;
        transform: translate(-70%, -50%) rotate(-45deg);
   }
`;
